import { render, staticRenderFns } from "./UniversalDetail.vue?vue&type=template&id=a98505b8&"
import script from "./UniversalDetail.vue?vue&type=script&lang=js&"
export * from "./UniversalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports